/* Copyright (c) 2017 Backpack Health LLC */

import * as _ from 'lodash';

import UserModel from '../../../models/UserModel';
import { authToken } from '../../../utilities/LocalStorage';
import UserService from '../../../apiServices/UserService';

export const types = {
  UPDATE_EMAIL: 'app/user/UPDATE_EMAIL',
  SET_LOCALE: 'app/user/SET_LOCALE',
  UPDATE_USER: 'UPDATE_MAIN_USER',
  RECEIVE_USER: 'RECEIVE_MAIN_USER',
};

const initialState = _.assign({
  profile_id: -1,
  email: '',
  locale_id: -1,
}, _.get(authToken.decode(), 'user', {}));

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case types.UPDATE_EMAIL:
      return _.assign({}, state, action.payload);
    case types.SET_LOCALE:
      return _.assign({}, state, {
        locale_id: action.payload.locale_id,
      });
    case types.UPDATE_USER:
      return _.assign({}, state, action.payload);
    case types.RECEIVE_USER:
      return _.assign({}, state, action.payload);
    default:
      return state;
  }
}

export function updateEmail(email) {
  return {
    type: types.UPDATE_EMAIL,
    payload: { email },
  };
}

function receiveUser(userData) {
  return dispatch => {
    return new Promise(res => {
      dispatch(_.assign({}, {
        type: types.RECEIVE_USER,
        payload: userData,
      }));
      res();
    });
  };
}

function setLocale({ id, language_code }, languageMessages) {
  return {
    type: types.SET_LOCALE,
    payload: {
      languageCode: language_code,
      locale_id: id,
      languageMessages,
    },
  };
}

function updateUser(userData) {
  return dispatch => {
    return new Promise(res => {
      dispatch(_.assign({}, {
        type: types.UPDATE_USER,
        payload: userData,
      }));
      res();
    });
  };
}

function submitUserUpdate(userData, callback) {
  return (dispatch) => {
    UserService.update(userData, (apiError) => {
      if (apiError) {
        callback(apiError, null);
        return;
      }

      dispatch(receiveUser(userData)).then(() => {
        callback(apiError, userData);
      });
    });
  };
}

function requestUser(userId, callback) {
  return (dispatch) => {
    return new Promise((res, rej) => {
      UserService.get(userId, (apiError, user) => {
        if (apiError) {
          rej(apiError);
          return;
        }
        dispatch(receiveUser(user.data)).then(() => {
          if (callback) { callback(user.data); }
          res(user);
        });
      });
    });
  };
}

function cancelPendingEmail(userId) {
  return (dispatch) => {
    return new Promise((res) => {
      UserService.cancelPendingEmail(userId).then(() => {
        dispatch(requestUser(userId, res));
      });
    });
  };
}

function requestEmailChange(userId, email, callback) {
  return (dispatch) => {
    UserService.requestEmailChange(userId, email, () => {
      dispatch(requestUser(userId, callback));
    });
  };
}

export const actions = {
  updateEmail,
  setLocale,
  updateUser,
  submitUserUpdate,
  requestUser,
  receiveUser,
  cancelPendingEmail,
  requestEmailChange,
};

export const selectors = {
  getEmail: (state) => state.user.email,
  getLocaleId: state => state.user.locale_id,
  getLoggedInUser: state => new UserModel(state.user),
  getUser: state => new UserModel(state.user),
  getMainProfileId: state => state.user.profile_id,
  isUserLoaded: state => !!state.user.cuid,
};
